import { rotateVar } from '../../../mixins/rotation/rotation.css-vars';

/**
 * CSS custom properties for the text widget — the LESS twin of the former JSS
 * `getStyles`. ONE module shared by both apps; the static rules consuming the
 * variables live in each component's `.less` (`text-view.component.less` /
 * `text.component.less`).
 *
 * The two styled elements are the flex `root` wrapper (justify / rotate /
 * z-index, per device) and the inner `content` block (width %, per device).
 * Group-level variables are computed per component (editor: `computed`
 * signals, published renderer: getters — the video/button pattern) from the
 * lookup + helpers exported here, bound individually `[style.--x]`.
 *
 * A `null` value removes the property from the element, so the consuming
 * declaration falls back to its `var()` default (or initial) — mirroring the
 * omitted-key behaviour of the old JSS object.
 */
/**
 * Content width as a percentage string, mirroring the legacy JSS rule:
 * widths above 100 are dropped (the element keeps its natural width), anything
 * else becomes `${width || 100}%`. Returns `null` to remove the property.
 */
export function textWidthCss(value: number | null | undefined): string | null {
    if (value != null && value > 100) {
        return null;
    }

    return `${value || 100}%`;
}

/** Rotation transform for the root wrapper. Zero blocks delegate rotation to the host. */
export function textTransformCss(rotate: number | null | undefined, isZero: boolean): string {
    return isZero ? 'none' : rotateVar(rotate);
}
